const Survey = () =>
    import ("./Survey.vue");
const NotFound = () =>
    import ("./NotFound.vue");
const SurveyСompleted = () =>
    import ("./SurveyСompleted.vue");    
const PollPas = () =>
    import ("./PollPas.vue");

const routes = [{
        path: 'PollPas/:selected_language',
        name: 'PollPas',
        component: PollPas,
    }, {
        path: '/*',
        name: 'Survey',
        component: Survey
    },
    {
        path: '*',
        name: 'NotFound',
        component: NotFound
    },
    {
        path: '*',
        name: 'SurveyСompleted',
        component: SurveyСompleted
    },
]

export default routes;